<template>
  <div id="app">
    <ControlPanel v-if="isAdmin" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <div
      class="floating-buttons-module"
      v-if="floatingButtonsModule && floatingButtonsModule.enabled"
    >
      <Component
        v-for="(button, idx) in floatingButtonsModule.items"
        v-bind:key="idx"
        v-bind:is="getFloatingButton(button.id)"
        v-bind:props="button.props"
      />
    </div>
  </div>
</template>

<script>
const ControlPanel = () => import("@/components/core/ControlPanel");
import FloatingButtonsModule from "@/utils/floating-buttons";
export default {
  data() {
    return {
      logos: {}
    }
  },
  metaInfo: {
    titleTemplate: `%s | ${process.env.VUE_APP_BRAND}`
  },
  head: {
    link: [{ rel: 'icon',type: 'image/png', sizes: '16x16', href: `https://firebasestorage.googleapis.com/v0/b/aig-empleados-m.appspot.com/o/logo_aig.png?alt=media&token=a7fb0594-c995-48fd-a58f-045b0b2f1145`}]
  },
  components: {
    ControlPanel,
  },
  computed: {
    isAdmin() {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.role == "ROOT";
      }
    },
    floatingButtonsModule() {
      return this.$store.state.system?.configs?.THEME?.floatingButtonsModule;
    },
  },
  methods: {
    getFloatingButton(id) {
      return FloatingButtonsModule.get(id);
    },
  },
  created() {},
};
</script>

<style lang="scss">
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}
</style>